import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "Icon",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.774 16.899 11.917 1.185a2.142 2.142 0 0 0-3.834 0L.226 16.9A2.143 2.143 0 0 0 2.143 20h15.714a2.142 2.142 0 0 0 1.917-3.101M8.929 7.144a1.071 1.071 0 1 1 2.142 0v4.285a1.072 1.072 0 1 1-2.142 0zM10 17.143a1.429 1.429 0 1 1 0-2.858 1.429 1.429 0 0 1 0 2.858"
    }, null, -1)
  ])))
}
export default { render: render }